import {
  OrderTypes,
  ProductTypes,
  TransactionType
} from '@javascript/habitual-analytics/brokers/OrderFacade/types/common';
import { TransactionTypes } from '@javascript/habitual-analytics/domains';
import _ from 'lodash';

export const formatOrderType = (orderType: string): OrderTypes => {
  const type = _.trim(orderType.toLowerCase());
  switch (type) {
    case 'l':
      return OrderTypes.LIMIT;
    case 'sl-m':
      return OrderTypes.SL_M;
    case 'sl':
      return OrderTypes.SL_L;
    default:
      return OrderTypes.MARKET;
  }
};

export const formatTransactionType = (orderType: TransactionTypes): TransactionType => {
  return orderType === 'buy' ? TransactionType.BUY : TransactionType.SELL;
};

export const extractOrderType = (orderType: string): OrderTypes => {
  const splitedOrderType = orderType.split('/')[0];
  switch (splitedOrderType) {
    case 'LIMIT':
      return OrderTypes.LIMIT;
    case 'SL_L':
      return OrderTypes.SL_L;
    case 'SL-M':
      return OrderTypes.SL_M;
    default:
      return OrderTypes.MARKET;
  }
};

export const extractProductType = (productType: string): ProductTypes => {
  const splitProductType = productType.split('/')[1];
  if (splitProductType === 'CNC') {
    return ProductTypes.CNC;
  }
  if (splitProductType === 'NRML') {
    return ProductTypes.NRML;
  }
  return ProductTypes.MIS;
};
